"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Routes = void 0;
var Routes;
(function (Routes) {
    Routes["Home"] = "home";
    Routes["Setup"] = "setup";
    Routes["Buy"] = "buy";
    Routes["BuyV2"] = "buy2";
    Routes["Sell"] = "sell";
    Routes["Deposit"] = "deposit";
    Routes["History"] = "history";
    Routes["PrepareWithdrawal"] = "prepare-withdrawal";
    Routes["CompleteWithdrawal"] = "complete-withdrawal";
    Routes["Transfer"] = "transfer";
    Routes["Cancel"] = "cancel";
})(Routes = exports.Routes || (exports.Routes = {}));
